import Image from '@components/Image';
import type {ReactElement} from 'react';

interface Props {
    image: string;
}

export default function PicsOption(props: Props): ReactElement<Props> {
    return (
        <div className="pics-option">
            <Image src={props.image} className="pics-option__picture" />
        </div>
    );
}
